// packages/world-model/src/traits/light-source/index.ts

export { LightSourceTrait } from './lightSourceTrait.js';
export { LightSourceBehavior } from './lightSourceBehavior.js';
